import UnsubscribePage from "./unsubscribe";

export default UnsubscribePage;
